import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  CircularProgress,
  IconButton,
  Checkbox,
  Snackbar,
  Fade,
  Slide,
  Chip,
  Card,
  CardContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  Avatar,
  alpha
} from '@mui/material';
import {
  ArrowBack,
  Edit,
  Delete,
  CalendarToday,
  Assignment,
  Download,
  Visibility,
  Send,
} from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { decryptAppId, decryptText, encryptText, encryptAppId } from "../utils/encryption";
import acProcessService from '../services/acProcessService';
import axios from 'axios';
import s3Utils from '../utils/s3Utils';
import FileUploadComponent from './FileUploadComponent';
import CertificateDialog from './certificate/CertificateDialog';
import CommonAPIService from '../services/commonAPIService';
const { generateCommunicationLetter } = await import('./certificate/CommunicationLetterGenerator');
const { generateDecisionLetter } = await import('./certificate/DecisionLetterGenerator');

// Hardcoded AC Type options
const acTypeOptions = [
  { value: '0', label: '-----Select-----' },
  { value: 'SEC', label: 'SEC' },
  { value: 'CAT', label: 'CAT' },
  { value: 'CAM', label: 'CAM' },
  { value: 'CAC', label: 'CAC' },
  { value: 'SAC', label: 'SAC' },
  { value: 'CAT (Integrated)', label: 'CAT (Integrated)' },
  { value: 'PTP', label: 'PTP' },
  { value: 'RMP', label: 'RMP' },
  { value: 'Review Committee', label: 'Review Committee' },
];

// Color definitions
const colors = {
  primary: {
    main: '#667eea',
    dark: '#5a67d8'
  },
  secondary: {
    main: '#764ba2',
    dark: '#5a3780'
  }
};

const ACProcess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get encrypted parameters from URL
  const encryptedAppId = searchParams.get("appId");
  const encryptedOrgId = searchParams.get("orgId");
  const encryptedAssessmentId = searchParams.get("assessmentId");

  // Decrypt parameters
  const appIdFromUrl = encryptedAppId ? decryptAppId(encryptedAppId) : null;
  const orgIdFromUrl = encryptedOrgId ? decryptText(encryptedOrgId) : null;
  const assessmentIdFromUrl = encryptedAssessmentId ? decryptText(encryptedAssessmentId) : null;

  // State management
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [appId, setAppId] = useState(appIdFromUrl);
  const [orgId, setOrgId] = useState(orgIdFromUrl);
  const [assessmentId, setAssessmentId] = useState(assessmentIdFromUrl);
  const [application, setApplication] = useState(null);
  const [stage, setStage] = useState('');

  // Date Selection State
  const [showChooseDate, setShowChooseDate] = useState(false);
  const [ddlTypeOfAc, setDdlTypeOfAc] = useState('0');
  const [ddlDate, setDdlDate] = useState('0');
  const [ddlDateTo, setDdlDateTo] = useState('0');
  const [txtRemarks, setTxtRemarks] = useState('');
  const [dateOptions, setDateOptions] = useState([]);
  const [dateToOptions, setDateToOptions] = useState([]);
  const [repeaterData, setRepeaterData] = useState([]);
  const [showDateDiv, setShowDateDiv] = useState(true);
  const [showRepeaterDiv, setShowRepeaterDiv] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);

  // Modal States
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [txtPassword, setTxtPassword] = useState('');

  // Send To joint Director States
  const [showSendToDirectorModal, setShowSendToDirectorModal] = useState(false);
  const [directorList, setDirectorList] = useState([]);
  const [selectedDirector, setSelectedDirector] = useState('0');
  const [directorPassword, setDirectorPassword] = useState('');
  const [loadingDirectors, setLoadingDirectors] = useState(false);

  // Final Status State
  const [showFinalStatus, setShowFinalStatus] = useState(false);
  const [ddlStatus, setDdlStatus] = useState('0');
  const [momFileData, setMomFileData] = useState(null);

  // Certificate related states
  const [showDivC, setShowDivC] = useState(false);
  const [rblCertNo, setRblCertNo] = useState('');
  const [showDivCertno, setShowDivCertno] = useState(false);
  const [txtBoxCert, setTxtBoxCert] = useState('');
  const [txtCertificateNo, setTxtCertificateNo] = useState('');
  const [showGenerateCertModal, setShowGenerateCertModal] = useState(false);
  const [txtGeneratePassword, setTxtGeneratePassword] = useState('');

  // Certificate Dialog state
  const [showCertificateDialog, setShowCertificateDialog] = useState(false);

  // Date related states
  const [showDivIssueDate, setShowDivIssueDate] = useState(false);
  const [txtIssueDate, setTxtIssueDate] = useState('');
  const [showDivToDate, setShowDivToDate] = useState(false);
  const [txtToDate, setTxtToDate] = useState('');
  const [showDivAmendment, setShowDivAmendment] = useState(false);
  const [txtAmendmentDate, setTxtAmendmentDate] = useState('');

  // Activity related states
  const [showDivNextDueActivity, setShowDivNextDueActivity] = useState(false);
  const [ddlNextDueActivity, setDdlNextDueActivity] = useState('0');
  const [showDivExpectedDate, setShowDivExpectedDate] = useState(false);
  const [txtExpectedDate, setTxtExpectedDate] = useState('');

  // File upload states
  const [iacFileInState, setIacFileInState] = useState('');
  const [uploadedIACFile, setUploadedIACFile] = useState(null);
  const [fileUploadKey, setFileUploadKey] = useState(0);

  // Remarks states
  const [showDivRemarks, setShowDivRemarks] = useState(false);
  const [txtRemark, setTxtRemark] = useState('');
  const [showDivShowcauseRemarks, setShowDivShowcauseRemarks] = useState(false);
  const [txtShowcauseRemarks, setTxtShowcauseRemarks] = useState('');

  // Discipline states
  const [showDivDiscipline, setShowDivDiscipline] = useState(false);
  const [disciplines, setDisciplines] = useState([]);
  const [selectedDisciplines, setSelectedDisciplines] = useState([]);

  // Assessment states
  const [showDivReAssessType, setShowDivReAssessType] = useState(false);
  const [rbAssesstype, setRbAssesstype] = useState('');

  // Adverse decision states
  const [showAdverseDecision, setShowAdverseDecision] = useState(false);
  const [rbCoolingPeriod, setRbCoolingPeriod] = useState('0');
  const [txtCollingPeriod, setTxtCollingPeriod] = useState('');

  // Other states
  const [showDivRejctdRmrk, setShowDivRejctdRmrk] = useState(false);
  const [txtRejectedRemarks, setTxtRejectedRemarks] = useState('');
  const [showLnkFinal, setShowLnkFinal] = useState(false);
  const [showLnkGenerateBtn, setShowLnkGenerateBtn] = useState(false);
  const [showLnkProcceedforDecision, setShowLnkProcceedforDecision] = useState(false);
  const [showHlDecision, setShowHlDecision] = useState(false);
  const [showDecisionModal, setShowDecisionModal] = useState(false);

  // Decision Process States
  const [communicationSubject, setCommunicationSubject] = useState('');
  const [communicationBody, setCommunicationBody] = useState('');
  const [communicationLetterDate, setCommunicationLetterDate] = useState('');
  const [decisionPassword, setDecisionPassword] = useState('');
  const [showDecisionPasswordModal, setShowDecisionPasswordModal] = useState(false);
  const [sendLetterPassword, setSendLetterPassword] = useState('');
  const [showSendLetterModal, setShowSendLetterModal] = useState(false);
  const [advisoryList, setAdvisoryList] = useState([]);
  const [hasDecisionData, setHasDecisionData] = useState(false);

  // Scope data for certificate
  const [scopeData, setScopeData] = useState(null);
  const [certificateMainData, setCertificateMainData] = useState(null);
  const [loadingScopeData, setLoadingScopeData] = useState(false);

  // Encrypted assessment ID from URL

  // Snackbar State
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info'
  });

  const showSnackbar = (message, severity = 'info') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Fetch Directors/CEO List
  const fetchDirectorsList = async () => {
    try {
      setLoadingDirectors(true);
      const response = await axios.get(`${process.env.REACT_APP_DOT_NET_CORE_API_URL}/ceolist`,
        {
          params: {
            appid: appId,
            usertypeid: 9,
          }
        }
      );

      if (response.data && response.data.ceo) {
        setDirectorList(response.data.ceo);
      } else {
        setDirectorList([]);
      }
    } catch (error) {
      console.error('Error fetching directors list:', error);
      showSnackbar('Error loading directors list', 'error');
      setDirectorList([]);
    } finally {
      setLoadingDirectors(false);
    }
  };

  // Handle Send To Joint Director
  const handleSendToDirector = async () => {
    try {
      // Validation
      if (selectedDirector === '0') {
        showSnackbar('Please select a director', 'warning');
        return;
      }

      if (!directorPassword.trim()) {
        showSnackbar('Please enter password', 'warning');
        return;
      }

      // Verify password
      const orgId = localStorage.getItem('orgId');
      const passwordResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/verify-password`,
        {
          orgId: orgId,
          password: directorPassword
        }
      );

      if (!passwordResponse.data.success) {
        showSnackbar('Invalid password', 'error');
        return;
      }

      // Send to joint director API call
      const payload = {
        forwardto: selectedDirector,
        appid: appId.toString(),
        updatedby: orgId
      };

      const response = await axios.post(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/sendtodirector`,
        payload
      );

      showSnackbar('Application successfully sent to director', 'success');
      setShowSendToDirectorModal(false);
      setSelectedDirector('0');
      setDirectorPassword('');

      // Navigate back after a short delay
      // setTimeout(() => {
      //   navigate(
      //     `/main/do/applications/appdashboard?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}`
      //   );
      // }, 2000);
    } catch (error) {
      console.error('Error sending to director:', error);
      showSnackbar(
        error.response?.data?.message || 'Error sending to director. Please try again.',
        'error'
      );
    }
  };

  // Open Send To joint Director Modal
  const handleOpenSendToDirector = () => {
    fetchDirectorsList();
    setShowSendToDirectorModal(true);
  };

  // Decision Process Handlers
  const loadDecisionData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Getdecision`, {
        params: {
          appid: appId,
          orgid: orgId
        }
      });

      if (response.data) {
        setCommunicationSubject(response.data.subject || '');
        setCommunicationBody(response.data.body || '');
        setCommunicationLetterDate(response.data.date || '');
        // Check if both subject and body exist
        const hasData = !!(response.data.subject && response.data.body);
        setHasDecisionData(hasData);
      } else {
        setHasDecisionData(false);
      }
    } catch (err) {
      console.error('Error loading decision data:', err);
      setHasDecisionData(false);
    }
  };

  const loadCommunicationData = async (appId, orgId) => {
    try {
      const commResponse = await axios.get(`${process.env.REACT_APP_DOT_NET_CORE_API_URL}/GetCommunication`, {
        params: { appid: appId, orgid: orgId }
      });

      const subject = commResponse.data?.subject || '';
      const body = commResponse.data?.body || '';
      const date = commResponse.data?.date || '';
      // Return the data for immediate use
      return {
        subject,
        body,
        date
      };
    } catch (err) {
      console.error('Error loading communication data:', err);
      return {
        subject: '',
        body: '',
        date: ''
      };
    }
  };

  // Handle View Communication Letter
  const handleViewCommunicationLetter = async () => {
    try {
      showSnackbar('Fetching communication letter...', 'info');

      const communicationData = await loadCommunicationData(appId, orgId);

      if (!application) {
        showSnackbar('Application data not loaded. Please wait and try again.', 'warning');
        return;
      }

      const letterData = {
        applicationNo: application.ApplicationNo || 'N/A',
        letterDate: communicationData.date ? new Date(communicationData.date).toLocaleDateString('en-GB') : '',
        contactPerson: application.ContactPerson || 'N/A',
        laboratoryName: application.LaboratoryName || 'N/A',
        address: application.Address || 'N/A',
        extAddress: application.ExtAddress || 'N/A',
        mobile: application.ContactMobile || 'N/A',
        email: application.ContactEmail || 'N/A',
        subject: communicationData.subject || 'N/A',
        body: communicationData.body || 'N/A',
        advisoryList: advisoryList || [],
        doName: application.DoName || 'N/A',
        doEmail: application.DoEmail || 'N/A',
        showAdverseNote: false,
        showNewAddress: new Date() > new Date('2025-07-18')
      };

      await generateCommunicationLetter(letterData);
      showSnackbar('Communication letter downloaded successfully', 'success');
    } catch (err) {
      console.error('Error generating communication letter:', err);
      showSnackbar('Failed to generate communication letter', 'error');
    }
  };

  // Handle Form 11
  // const handleForm11 = () => {
  //   const encryptedappid = encryptAppId(appId.toString());
  //   const encryptedorgid = encryptText(orgId.toString());
  //   const form11url = `/main/jd/form11?appId=${encryptedappid}&orgId=${encryptedorgid}`;
  //   navigate(form11url);
  // };

   const handleForm11 = async () => {
    const response = await CommonAPIService.getAssessmentSendToNABLDate(appId);
        if (response.success && response.data) {
          const encryptedappid = encryptAppId(appId.toString());
          const encryptedorgid = encryptText(orgId.toString());
          if (response.data.isDisplayNew) {
          const form11url = `/main/jd/form11-new?appId=${encryptedappid}&orgId=${encryptedorgid}`;
          navigate(form11url);
          }else{
         const form11url = `/main/jd/form11?appId=${encryptedappid}&orgId=${encryptedorgid}`;
          navigate(form11url);
          }
      }
  };

  // Handle Edit Certificate
  const handleEditCertificate = () => {
    const encryptedappid = encryptAppId(appId.toString());
    const encryptedorgid = encryptText(orgId.toString());
    const editCertificateUrl = `/main/jd/edit-scope-certificate?appId=${encryptedappid}&orgId=${encryptedorgid}`;
    navigate(editCertificateUrl);
  };

  const handleSubmitDecision = () => {
    // Validate required fields
    if (!communicationSubject.trim()) {
      showSnackbar('Please enter Decision Letter Subject', 'warning');
      return;
    }
    if (!communicationBody.trim()) {
      showSnackbar('Please enter Decision Letter Body', 'warning');
      return;
    }

    setShowDecisionPasswordModal(true);
  };

  const handleDecisionPasswordSubmit = async () => {
    if (!decisionPassword.trim()) {
      showSnackbar('Please enter password', 'warning');
      return;
    }

    try {
      // Verify password first
      const passwordResponse = await axios.post(`${process.env.REACT_APP_API_URL}/auth/verify-password`, {
        orgId: localStorage.getItem('orgId') || '0',
        password: decisionPassword
      });

      if (!passwordResponse.data.success) {
        showSnackbar('Invalid password', 'error');
        return;
      }

      // Save decision
      const response = await axios.post(`${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Savedecision`, {
        appId: appId,
        orgid: orgId,
        subject: communicationSubject.trim(),
        body: communicationBody.trim()
      });

      if (response.data && response.data.isstatus) {
        showSnackbar('Decision submitted successfully', 'success');
        setShowDecisionPasswordModal(false);
        setDecisionPassword('');
        // Update hasDecisionData to show Send To Joint Director button
        if (communicationSubject.trim() && communicationBody.trim()) {
          setHasDecisionData(true);
        }
      } else {
        showSnackbar('Failed to submit decision', 'error');
      }
    } catch (err) {
      console.error('Error submitting decision:', err);
      showSnackbar(err.response?.data?.message || 'Invalid password', 'error');
    }
  };

  const handleViewLetter = async () => {
    try {
      showSnackbar('Fetching decision letter...', 'info');

      // Check if application data is available
      if (!application) {
        showSnackbar('Application data not loaded. Please wait and try again.', 'warning');
        return;
      }
      // Prepare letter data
      const letterData = {
        applicationNo: application.ApplicationNo || 'N/A',
        letterDate: communicationLetterDate ? new Date(communicationLetterDate).toLocaleDateString('en-GB') : '',
        contactPerson: application.ContactPerson || 'N/A',
        laboratoryName: application.LaboratoryName || 'N/A',
        address: application.Address || 'N/A',
        extAddress: application.ExtAddress || 'N/A',
        mobile: application.ContactMobile || 'N/A',
        email: application.ContactEmail || 'N/A',
        subject: communicationSubject || 'N/A',
        body: communicationBody || 'N/A',
        doName: application.DoName || 'N/A',
        doEmail: application.DoEmail || 'N/A',
        showAdverseNote: false,
        showNewAddress: new Date() > new Date('2025-07-18')
      };

      // Generate PDF
      await generateDecisionLetter(letterData);

      showSnackbar('Decision letter downloaded successfully', 'success');
    } catch (err) {
      console.error('Error generating letter:', err);
      showSnackbar('Failed to generate decision letter', 'error');
    }
  };

  const handleSendLetter = () => {
    setShowSendLetterModal(true);
  };

  const handleSendLetterSubmit = async () => {
    if (!sendLetterPassword.trim()) {
      showSnackbar('Please enter password', 'warning');
      return;
    }

    try {
      // Verify password first
      const passwordResponse = await axios.post(`${process.env.REACT_APP_API_URL}/auth/verify-password`, {
        orgId: localStorage.getItem('orgId') || '0',
        password: sendLetterPassword
      });

      if (!passwordResponse.data.success) {
        showSnackbar('Invalid password', 'error');
        return;
      }

      // Send decision
      const response = await axios.post(`${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Senddecision`, {
        appId: appId,
        updatedby: localStorage.getItem('orgId') || '0',
        orgid: orgId
      });

      if (response.data && response.data.isstatus) {
        showSnackbar('Letter sent successfully', 'success');
        setShowSendLetterModal(false);
        setSendLetterPassword('');
        setShowDecisionModal(false);
      } else {
        showSnackbar('Failed to send letter', 'error');
      }
    } catch (err) {
      console.error('Error sending letter:', err);
      showSnackbar(err.response?.data?.message || 'Invalid password', 'error');
    }
  };

  // Load application data on mount
  useEffect(() => {
    if (appId) {
      initializePage();
    }
  }, [appId]);

  const initializePage = async () => {
    try {
      setLoading(true);
      setError(null);

      const [appDetailsResponse, labHeadResponse, doResponse] = await Promise.all([
        // Get application details (ApplicationNo, LaboratoryName, etc.)
        axios.get(`${process.env.REACT_APP_API_URL}/ac-process/application/details/${appId}`),
        // Get lab head/contact details (mode=27)
        axios.get(`${process.env.REACT_APP_API_URL}/do/allotment-details`, {
          params: {
            mode: 27,
            appId: appId
          }
        }),
        // Get DO details (mode=31)
        axios.get(`${process.env.REACT_APP_API_URL}/do/allotment-details`, {
          params: {
            mode: 31,
            appId: appId
          }
        })
      ]);

      // Extract data from responses
      const appData = appDetailsResponse.data?.data || {};
      const labHeadData = labHeadResponse.data?.data?.[0] || {};
      const doData = doResponse.data?.data?.[0] || {};

      // Combine data
      const appDetails = {
        ApplicationNo: appData.ApplicationNo || 'N/A',
        LaboratoryName: appData.LaboratoryName || 'N/A',
        LabType: appData.LabType || 'N/A',
        LabTypeId: appData.LabTypeId || null,
        AssessmentTypeId: appData.AssessmentTypeId || null,
        AssessmentType: appData.AssessmentType || 'N/A',
        ContactPerson: labHeadData.name || 'N/A',
        Address: labHeadData.address || 'N/A',
        ExtAddress: `${labHeadData.city || 'N/A'} ${labHeadData.state || 'N/A'} ${labHeadData.pincode || 'N/A'}`.trim(),
        ContactMobile: labHeadData.mobile || 'N/A',
        ContactEmail: labHeadData.email || 'N/A',
        DoName: doData.name || 'N/A',
        DoEmail: doData.email || 'N/A',
        Stage: appData.Stage || 'N/A',
        CommunicationLetterSent: appData.CommunicationLetterSent || 0,
      };

      setApplication(appDetails);
      setStage(appDetails.Stage);
      setShowHlDecision(appDetails?.CommunicationLetterSent === 0);

      // Set certificate prefix based on LabTypeIdf
      if (appDetails.LabTypeId) {
        switch (appDetails.LabTypeId) {
          case 1:
            setTxtBoxCert('TC');
            break;
          case 2:
            setTxtBoxCert('CC');
            break;
          case 3:
            setTxtBoxCert('MC');
            break;
          case 4:
            setTxtBoxCert('PC');
            break;
          case 5:
            setTxtBoxCert('RC');
            break;
          default:
            setTxtBoxCert('');
        }
      }

      // Load data based on stage
      if (['6b', '6d', '6f', '11b'].includes(appDetails.Stage)) {
        await loadDateSelectionData(appId, appDetails.Stage);
        setShowChooseDate(true);
        setShowFinalStatus(false);
      } else if (['6e', '7', '7a', '7b', '7c', '7d', '7e', '7f', '7g', '7h', '12', '12a', '12b', '12c', '14', '14a', '13e', '13', '13a', '13b', '13c', '13d', '11f', '11g', '11i'].includes(appDetails.Stage)) {
        // await loadFinalStatusData(appId, appDetails.Stage);
        await loadMOMFileData(appId);
        // Load AC Status data if LabTypeId available
        if (appDetails.LabTypeId) {
          await loadACStatusData(appId, appDetails.LabTypeId, orgId);
        }
        // Load communication data for communication letter
        //await loadCommunicationData();
        // Load decision data to check if Send To Joint Director button should be shown
        await loadDecisionData();
        setShowChooseDate(false);
        setShowFinalStatus(true);
      }

    } catch (err) {
      console.error('Error initializing page:', err);
      setError('Failed to load application data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Load date selection data
  const loadDateSelectionData = async (appId, stage) => {
    try {
      const response = await acProcessService.getACProcessDetails(appId, orgId);
      setRepeaterData(response.data || []);

      if (response.data.length > 0) {
        if (stage === '6f') {
          setShowDateDiv(true);
        } else {
          setShowDateDiv(false);
        }
        setShowRepeaterDiv(true);
      } else {
        setShowDateDiv(true);
        setShowRepeaterDiv(false);
      }
    } catch (err) {
      console.error('Error loading date selection data:', err);
    }
  };

  // Load MOM File data
  const loadMOMFileData = async (appId) => {
    try {
      const response = await acProcessService.getMOMFileByAppId(appId);
      if (response.data && response.data.length > 0) {
        setMomFileData(response.data[0]);
      }
    } catch (err) {
      console.error('Error loading MOM file data:', err);
    }
  };

  // Load AC Status data
  const loadACStatusData = async (appId, labTypeId, orgId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Getacstatus`, {
        params: {
          appid: appId,
          labtypeid: labTypeId,
          orgid: orgId
        }
      });

      if (response.data && response.data.isstatus) {
        const statusData = response.data;

        // Populate form fields with fetched data
        if (statusData.aC_Status) {
          setDdlStatus(statusData.aC_Status);
          // Trigger status change to show appropriate fields
          setTimeout(() => handleStatusChange(statusData.aC_Status), 100);
        }

        if (statusData.remarks) {
          setTxtRemark(statusData.remarks);
        }

        if (statusData.toDate) {
          setTxtToDate(statusData.toDate);
        }

        if (statusData.amendmentDate) {
          setTxtAmendmentDate(statusData.amendmentDate);
        }

        if (statusData.reCert_No) {
          setTxtCertificateNo(statusData.reCert_No);
        } else if (statusData.cert_No) {
          setTxtCertificateNo(statusData.cert_No);
        }

        if (statusData.issue_Date) {
          setTxtIssueDate(statusData.issue_Date);
        }

        if (statusData.nextDueActivity) {
          setDdlNextDueActivity(statusData.nextDueActivity);
        }

        if (statusData.expectedDate) {
          // Convert DD/MM/YYYY to YYYY-MM-DD for date input
          const dateParts = statusData.expectedDate.split('/');
          if (dateParts.length === 3) {
            const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
            setTxtExpectedDate(formattedDate);
          } else {
            setTxtExpectedDate(statusData.expectedDate);
          }
        }

        if (statusData.iaC_Minutes) {
          setIacFileInState(statusData.iaC_Minutes);
          setUploadedIACFile(createFileObject(statusData.iaC_Minutes));
        }

        if (statusData.isCollingOffPeriod === '1' && statusData.collingOffPeriodDate) {
          setRbCoolingPeriod('1');
          setTxtCollingPeriod(statusData.collingOffPeriodDate);
        }

        console.log('AC Status data loaded successfully:', statusData);
      }
    } catch (err) {
      console.error('Error loading AC status data:', err);
      // Don't show error to user - it's optional data
    }
  };

  const createFileObject = (fileName) => {
    if (!fileName) return null;
    return {
      fileName: fileName,
      key: `live/${fileName}`,
      originalName: fileName,
    };
  };

  // Bind AC date options
  const bindDateOptions = async (acType) => {
    try {
      const response = await acProcessService.getACDatesByType(acType);
      setDateOptions(response.data || []);
      return response.data || [];
    } catch (err) {
      console.error('Error loading date options:', err);
      return [];
    }
  };

  // Bind AC date To options
  const bindDateToOptions = async (acType, dateFrom, dateOptionsArray = null) => {
    try {
      const optionsToUse = dateOptionsArray || dateOptions;
      const selectedDate = optionsToUse.find(d => d.Id && d.Id.toString() === dateFrom.toString());
      if (!selectedDate) {
        console.error('Selected date not found', dateFrom, optionsToUse);
        return [];
      }
      const response = await acProcessService.getACDateToByType(acType, selectedDate.Date);
      setDateToOptions(response.data || []);
      return response.data || [];
    } catch (err) {
      console.error('Error loading date to options:', err);
      return [];
    }
  };

  // Handle AC Type change
  const handleAcTypeChange = (value) => {
    setDdlTypeOfAc(value);
    setDdlDate('0');
    setDdlDateTo('0');
    if (value !== '0') {
      bindDateOptions(value);
    }
  };

  // Handle Date From change
  const handleDateChange = (value) => {
    setDdlDate(value);
    setDdlDateTo('0');
    if (value !== '0' && ddlTypeOfAc !== '0') {
      const selectedDate = dateOptions.find(d => d.Id.toString() === value);
      if (selectedDate) {
        bindDateToOptions(ddlTypeOfAc, value);
      }
    }
  };

  // Submit AC Date
  const handleSubmitDate = () => {
    // Validate
    if (ddlTypeOfAc === '0') {
      showSnackbar('Please Select Type of AC', 'warning');
      return;
    }
    if (ddlDate === '0') {
      showSnackbar('Please Select From Date', 'warning');
      return;
    }
    if (ddlDateTo === '0') {
      showSnackbar('Please Select To Date', 'warning');
      return;
    }
    if (!txtRemarks.trim()) {
      showSnackbar('Please Enter Remarks', 'warning');
      return;
    }

    checkDateRestriction();
  };

  const checkDateRestriction = async () => {
    try {
      const selectedDate = dateOptions.find(d => d.Id.toString() === ddlDate);
      if (!selectedDate) return;

      const response = await acProcessService.checkDateTimeValidity(selectedDate.Date, 3);

      if (response.data && response.data.length > 0) {
        setShowPasswordModal(true);
      } else {
        showSnackbar('Agenda can not be punched now.', 'warning');
      }
    } catch (err) {
      console.error('Error checking date restriction:', err);
      showSnackbar('Error validating date. Please try again.', 'error');
    }
  };

  // Submit with password
  const handlePasswordSubmit = async () => {
    try {
      if (!txtPassword.trim()) {
        showSnackbar('Please enter password', 'warning');
        return;
      }
      const orgId = localStorage.getItem('orgId');
      const passwordResponse = await axios.post(`${process.env.REACT_APP_API_URL}/auth/verify-password`, {
        orgId: orgId,
        password: txtPassword
      });
      if (!passwordResponse.data.success) {
        showSnackbar('Invalid password', 'error');
        return;
      }
      const payload = {
        appid: appId,
        acDate: ddlDate,
        acDateTo: ddlDateTo,
        acType: ddlTypeOfAc,
        doRemarks: txtRemarks,
        insertedBy: orgId,
        updatedBy: orgId,
        id: editingId
      };
      const response = isUpdate
        ? await acProcessService.updateACProcess(payload)
        : await acProcessService.insertACProcess(payload);

      if (response.status === 'success' || response.message) {
        await acProcessService.updateApplicationStage(appId, '6d');

        setShowPasswordModal(false);
        setTxtPassword('');
        showSnackbar('Date successfully alloted for AC Process.', 'success');

        await loadDateSelectionData(appId, stage);

        setDdlTypeOfAc('0');
        setDdlDate('0');
        setDdlDateTo('0');
        setTxtRemarks('');
        setIsUpdate(false);
        setEditingId(null);
        setDateOptions([]);
        setDateToOptions([]);
      } else {
        showSnackbar('Failed to submit date', 'error');
      }
    } catch (err) {
      console.error('Error submitting date:', err);
      showSnackbar('Invalid password or error occurred', 'error');
    }
  };

  // Edit date from repeater
  const handleEditDate = async (item) => {
    setDdlTypeOfAc(item.AC_Type);
    setIsUpdate(true);
    setEditingId(item.Id);
    setShowDateDiv(true);

    // Load date options for the selected AC type
    const loadedDateOptions = await bindDateOptions(item.AC_Type);
    setDdlDate(item.dateid.toString());

    // Load date To options
    if (loadedDateOptions && loadedDateOptions.length > 0) {
      await bindDateToOptions(item.AC_Type, item.dateid.toString(), loadedDateOptions);
      setDdlDateTo(item.dateidTo.toString());
    }

    setTxtRemarks(item.Do_Remarks);
  };

  // Cancel edit and reset form
  const handleCancelEdit = () => {
    setDdlTypeOfAc('0');
    setDdlDate('0');
    setDdlDateTo('0');
    setTxtRemarks('');
    setIsUpdate(false);
    setEditingId(null);
    setDateOptions([]);
    setDateToOptions([]);
    setShowDateDiv(false);
  };

  // Delete date from repeater
  const handleDeleteDate = async (id) => {
    if (!window.confirm('Do you want to Delete?')) return;

    try {
      const response = await acProcessService.deactivateACProcess(appId, id);
      if (response.status === 'success' || response.message) {
        showSnackbar('Successfully Deleted the date', 'success');
        await loadDateSelectionData(appId, stage);
      } else {
        showSnackbar('Failed to delete date', 'error');
      }
    } catch (err) {
      console.error('Error deleting date:', err);
      showSnackbar('Error occurred while deleting', 'error');
    }
  };

  // Generate certificate number
  const handleGenerateCertificate = async () => {
    try {
      if (!txtGeneratePassword.trim()) {
        showSnackbar('Please enter password', 'warning');
        return;
      }
      const orgId = localStorage.getItem('orgId');
      const passwordResponse = await axios.post(`${process.env.REACT_APP_API_URL}/auth/verify-password`, {
        orgId: orgId,
        password: txtGeneratePassword
      });

      if (!passwordResponse.data.success) {
        showSnackbar('Invalid password', 'error');
        return;
      }
      const response = await axios.post(`${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Genratecertificatenumber?appid=${appId}`);
      console.log('Certificate generation response:', response.data);
      if (response.data && response.data.isstatus) {
        setShowGenerateCertModal(false);
        setTxtGeneratePassword('');
        showSnackbar('Certificate No generated successfully.', 'success');
        await initializePage();
      } else {
        showSnackbar(response.data?.message || 'Failed to generate certificate', 'error');
      }
    } catch (err) {
      console.error('Error generating certificate:', err);
      showSnackbar('Invalid password or error occurred', 'error');
    }
  };

  // Handle status change in Final Status dropdown
  const handleStatusChange = (value) => {
    setDdlStatus(value);

    // Reset visibility states
    setShowDivC(false);
    setShowDivCertno(false);
    setShowDivIssueDate(false);
    setShowDivToDate(false);
    setShowDivNextDueActivity(false);
    setShowDivExpectedDate(false);
    setShowDivAmendment(false);
    setShowDivRemarks(false);
    setShowDivShowcauseRemarks(false);
    setShowDivDiscipline(false);
    setShowDivReAssessType(false);
    setShowAdverseDecision(false);
    setShowDivRejctdRmrk(false);
    setShowLnkFinal(false);
    setShowLnkGenerateBtn(false);
    setShowLnkProcceedforDecision(false);

    // Show relevant fields based on status
    if (value === 'Accreditation' || value === 'Accreditation With Advisory') {
      setShowDivC(true);
      setShowDivIssueDate(false);
      setShowDivToDate(false);
      setShowDivNextDueActivity(true);
      setShowDivExpectedDate(true);
      setShowDivAmendment(true);
      setShowDivRemarks(true);
      setShowLnkFinal(true);
    } else if (value === 'Accredited with advisory including show cause notice') {
      setShowDivC(true);
      setShowDivIssueDate(false);
      setShowDivToDate(false);
      setShowDivNextDueActivity(true);
      setShowDivExpectedDate(true);
      setShowDivAmendment(true);
      setShowDivShowcauseRemarks(true);
      setShowLnkFinal(true);
    } else if (value === 'Show Cause') {
      setShowDivC(true);
      setShowDivShowcauseRemarks(true);
      setShowLnkFinal(true);
    } else if (value === 'Denial' || value === 'Force Withdrwal' || value === 'Close' || value === 'Debar from Reapply Certification Preparation') {
      setShowDivC(true);
      //setShowAdverseDecision(true);
      setShowDivRemarks(true);
      setShowLnkFinal(true);
    } else if (value === 'Mark for Re Assessment') {
      setShowDivC(true);
      //setShowDivReAssessType(true);
      setShowDivRemarks(true);
      setShowLnkFinal(true);
    } else if (value === 'Abeyance' || value === 'Suspension') {
      setShowDivC(true);
      setShowDivRemarks(true);
      setShowLnkFinal(true);
    } else if (value === '0') {
      setShowLnkFinal(false);
    } else {
      setShowDivRemarks(true);
      setShowLnkFinal(true);
    }
  };

  // Handle certificate number generation choice
  const handleCertNoChange = (value) => {
    setRblCertNo(value);
    if (value === '1') {
      setShowLnkGenerateBtn(true);
      setShowDivCertno(false);
    } else {
      setShowLnkGenerateBtn(false);
      setShowDivCertno(true);
    }
  };

  // Calculate expected date based on To Date and Next Due Activity
  const calculateExpectedDate = () => {
    if (!txtToDate || ddlNextDueActivity === '0') return;

    try {
      const toDate = new Date(txtToDate);
      let expectedDate = new Date(toDate);

      if (ddlNextDueActivity === 'Desktop Application') {
        expectedDate.setFullYear(toDate.getFullYear() + 1);
        expectedDate.setMonth(toDate.getMonth() - 3); // 9 months from issue
      } else if (ddlNextDueActivity === 'Surveillance Application') {
        expectedDate.setFullYear(toDate.getFullYear() + 1);
        expectedDate.setMonth(toDate.getMonth() - 3); // 9 months from issue
      } else if (ddlNextDueActivity === 'Renewal Application') {
        expectedDate.setFullYear(toDate.getFullYear() - 1);
        expectedDate.setMonth(toDate.getMonth() + 10); // 10 months before expiry
      }

      // Format to YYYY-MM-DD
      const formattedDate = expectedDate.toISOString().split('T')[0];
      setTxtExpectedDate(formattedDate);
    } catch (err) {
      console.error('Error calculating expected date:', err);
    }
  };

  // Handle cooling period change
  const handleCoolingPeriodChange = (value) => {
    setRbCoolingPeriod(value);
  };

  // Handle file upload from FileUploadComponent
  const handleFileUploadChange = (fieldName, fileData) => {
    if (fieldName === 'iacFile') {
      if (fileData) {
        setUploadedIACFile(fileData);
        showSnackbar('IAC file uploaded successfully', 'success');
      } else {
        setUploadedIACFile(null);
      }
    }
  };

  // Check date validity - validates if date is at least N days in the future
  const checkDateValidity = async (dateToCheck, daysRequired = 3) => {
    try {
      // Convert date from YYYY-MM-DD to dd/MM/yyyy format for API
      const dateObj = new Date(dateToCheck);
      const day = String(dateObj.getDate()).padStart(2, '0');
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const year = dateObj.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;

      const response = await acProcessService.checkDateTimeValidity(formattedDate, daysRequired);

      if (response.data && response.data.length > 0 && response.data[0].chk === 1) {
        return false; // Date restriction violated
      }
      return true; // Date is valid
    } catch (err) {
      console.error('Error checking date validity:', err);
      return true; // Allow submission if validation fails
    }
  };

  // Handle Issue Date change with validation
  const handleIssueDateChange = async (e) => {
    const newDate = e.target.value;
    setTxtIssueDate(newDate);

    if (newDate) {
      const isDateValid = await checkDateValidity(newDate, 3);
      if (!isDateValid) {
        showSnackbar('Agenda can not be punched now.', 'warning');
      }
    }
  };

  // Handle Amendment Date change with validation
  const handleAmendmentDateChange = (e) => {
    const newDate = e.target.value;
    setTxtAmendmentDate(newDate);

    if (newDate && txtIssueDate && txtToDate) {
      const amendmentDate = new Date(newDate);
      const issueDate = new Date(txtIssueDate);
      const validityDate = new Date(txtToDate);

      if (amendmentDate < issueDate || amendmentDate > validityDate) {
        showSnackbar('Amendment date must be between Issue Date and Validity Till date.', 'warning');
      }
    }
  };

  // Handle final status submission
  const handleSubmitStatus = async () => {
    try {
      // Validation
      if (ddlStatus === '0') {
        showSnackbar('Please select final status', 'warning');
        return;
      }
      // Additional validations based on status
      if ((ddlStatus === 'Accreditation' || ddlStatus === 'Accreditation With Advisory' || ddlStatus === 'Accredited with advisory including show cause notice') &&
        (ddlNextDueActivity === '0' || !txtExpectedDate)) {
        showSnackbar('Please fill all required fields', 'warning');
        return;
      }
      if (showAdverseDecision && rbCoolingPeriod === '1' && !txtCollingPeriod) {
        showSnackbar('Please enter cooling off period date', 'warning');
        return;
      }

      // Validate Show Cause remarks
      if ((ddlStatus === 'Show Cause' || ddlStatus === 'Accredited with advisory including show cause notice') && !txtShowcauseRemarks.trim()) {
        showSnackbar('Please enter Show Cause remarks', 'warning');
        return;
      }

      // Validate Mark for Re Assessment fields
      if (ddlStatus === 'Mark for Re Assessment' && !rbAssesstype) {
        showSnackbar('Please select Assessment Type', 'warning');
        return;
      }

      // Validate regular remarks for statuses that require it
      if ((ddlStatus === 'Accreditation' || ddlStatus === 'Accreditation With Advisory' ||
        ddlStatus === 'Denial' || ddlStatus === 'Force Withdrwal' || ddlStatus === 'Close' ||
        ddlStatus === 'Debar from Reapply Certification Preparation' || ddlStatus === 'Mark for Re Assessment' ||
        ddlStatus === 'Abeyance' || ddlStatus === 'Suspension') && !txtRemark.trim()) {
        showSnackbar('Please enter remarks', 'warning');
        return;
      }

      //Date validation - check if issue date is valid (at least 3 days in future)
      if (txtIssueDate) {
        const isDateValid = await checkDateValidity(txtIssueDate, 3);
        if (!isDateValid) {
          showSnackbar('Agenda can not be punched now.', 'warning');
          return;
        }
      }

      // Validate amendment date is between issue date and validity date
      // if (txtAmendmentDate && txtIssueDate && txtToDate) {
      //   const amendmentDate = new Date(txtAmendmentDate);
      //   const issueDate = new Date(txtIssueDate);
      //   const validityDate = new Date(txtToDate);

      //   if (amendmentDate < issueDate || amendmentDate > validityDate) {
      //     showSnackbar('Amendment date must be between Issue Date and Validity Till date.', 'error');
      //     return;
      //   }
      // }

      setLoading(true);
      // Handle file upload - use uploaded file from FileUploadComponent
      let iacFilePath = iacFileInState || '';
      if (uploadedIACFile && uploadedIACFile.fileName) {
        iacFilePath = uploadedIACFile.fileName;
      }
      // Prepare data for mark status API
      const statusData = {
        appId: appId.toString(),
        orgid: orgIdFromUrl,
        status: ddlStatus,
        remarks: txtRemark || '',
        showCauseRemarks: txtShowcauseRemarks || '',
        toDate: txtToDate || '',
        nextDueActivity: ddlNextDueActivity === '0' ? '' : ddlNextDueActivity,
        expectedDate: txtExpectedDate || '',
        amendmentDate: txtAmendmentDate || '',
        certificateNo: txtCertificateNo || '',
        issueDate: txtIssueDate || '',
        coolingPeriod: rbCoolingPeriod || '0',
        coolingPeriodDate: txtCollingPeriod || '',
        generateNewCertNo: rblCertNo || '0',
        assessmentType: rbAssesstype || '',
        markForReAssessment: ddlStatus === 'Mark for Re Assessment' ? '1' : '0',
        filePath: iacFilePath
      };
      // Direct API call to Mark Status endpoint
      const response = await axios.post(`${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Markstatus`, statusData, {
        headers: { 'Content-Type': 'application/json' }
      }
      );
      if (response.data && response.data.isstatus) {
        showSnackbar(response.data.message || 'Final status submitted successfully', 'success');
        await initializePage();
      } else {
        showSnackbar(response.data?.message || 'Failed to submit final status', 'error');
      }

    } catch (err) {
      console.error('Error submitting final status:', err);
      const errorMessage = err.response?.data?.message || err.message || 'Failed to submit final status';
      showSnackbar(errorMessage, 'error');
    } finally {
      setLoading(false);
    }
  };

  // Fetch scope data from API
  const fetchScopeData = async () => {
    try {
      setLoadingScopeData(true);

      // Fetch certificate data (test records)
      const certificatemainDataResponse = await axios.get(`${process.env.REACT_APP_DOT_NET_CORE_API_URL}/GetMaincertificatedata?appid=${appId}&labtypeid=${application?.LabTypeId}`
      );
      // Fetch certificate data (test records)
      const certificateResponse = await axios.get(`${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Getcertificatedata?appid=${appId}&token=nablgvfdcrtyfbskgirwsoh`
      );

      // Fetch location data (certificate info)
      const locationResponse = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/CertificateLocation?appid=${appId}&check=nablgvfdcrtyfbskgirwsoh`
      );

      const certificateData = certificateResponse.data?.certificate || [];
      const locationData = locationResponse.data?.certlocation?.[0] || {};

      // Transform API data to match ScopeGenerator format
      const transformedRecords = certificateData.map(record => ({
        discipline: record.disciplineName || '',
        productMaterial: record.productMaterial || '',
        specificTest: record.specifictest || '',
        scopeYear: record.scopeyear || '',
        unit: record.unit || '',
        measr: record.measr || '',
        heading1: record.heading1 || '',
        heading2: record.heading2 || '',
        heading3: record.heading3 || '',
        heading4: record.heading4 || '',
        heading5: record.heading5 || '',
        heading6: record.heading6 || '',
        groupName: record.groupName || ''
      }));

      // Prepare scope data
      const scopeDataObj = {
        labName: locationData.labName || application?.LabName || application?.Organization_Name || '',
        location: locationData.location || application?.Address || '',
        standard: locationData.standard || '-',
        certificateNumber: locationData.cert_No || (txtBoxCert || '') + (txtCertificateNo || ''),
        issueDate: locationData.issue_Date ? new Date(locationData.issue_Date).toLocaleDateString('en-GB') : txtIssueDate ? new Date(txtIssueDate).toLocaleDateString('en-GB') : 'N/A',
        validUntil: locationData.validuntill ? new Date(locationData.validuntill).toLocaleDateString('en-GB') : txtToDate ? new Date(txtToDate).toLocaleDateString('en-GB') : 'N/A',
        amendmentDate: locationData.amendmentDate ? new Date(locationData.amendmentDate).toLocaleDateString('en-GB') : txtAmendmentDate ? new Date(txtAmendmentDate).toLocaleDateString('en-GB') : '',
        headerChange: locationData.isNew === '1',
        address: application?.Address || '',
        legalEntity: application?.LabName || application?.Organization_Name || '',
        field: application?.LabTypeId === 1 ? 'TESTING' :
          application?.LabTypeId === 2 ? 'CALIBRATION' :
            application?.LabTypeId === 3 ? 'MEDICAL' :
              application?.LabTypeId === 4 ? 'PTP' :
                application?.LabTypeId === 5 ? 'RMP' : '',
        records: transformedRecords,
        // Additional fields from API
        labType: locationData.labType || application?.LabType,
        validity: locationData.validity || '',
        permanent: locationData.permanent === '1',
        mobile: locationData.mobile === '1',
        site: locationData.site === '1',
        potc: locationData.potc === '1',
        appId: appId,
        orgId: orgIdFromUrl
      };
      setCertificateMainData(certificatemainDataResponse.data || {});
      setScopeData(scopeDataObj);
      setLoadingScopeData(false);
      return scopeDataObj;

    } catch (error) {
      console.error('Error fetching scope data:', error);
      setLoadingScopeData(false);
      showSnackbar('Failed to fetch scope data from API', 'warning');
      return null;
    }
  };

  // Handle opening certificate dialog with scope data
  const handleOpenCertificateDialog = async (action) => {
    // setShowCertificateDialog(true);
    window.open(`/main/viewCertificate?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&action=${encryptText(action)}`, '_blank');
    // Fetch scope data when dialog opens if not already fetched
    // if (!scopeData && appId) {
    //   await fetchScopeData();
    // }
  };

  const handleFileOpen = async (fileUrl) => {
    if (!fileUrl) {
      setError('No file available to view');
      return;
    }
    try {
      setLoading(true);
      // Use s3Utils to handle file opening with signed URLs
      await s3Utils.handleFileViewWithS3(fileUrl, {
        showError: (msg) => setError(msg),
        showLoading: () => setLoading(true),
        hideLoading: () => setLoading(false),
        expiresIn: 172800 // 48 hours
      });
    } catch (err) {
      setError('Failed to open file');
      console.error('Error opening file:', err);
    } finally {
      setLoading(false);
    }
  };

  // Render loading state
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Render error state
  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
        <Button onClick={() => navigate(`/main/jd/applications/appdashboard?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}`)} startIcon={<ArrowBack />} sx={{ mt: 2 }}>
          Go Back
        </Button>
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ p: 2, maxWidth: 1400, mx: "auto" }}>
        {/* Modern Header with Gradient Background */}
        <Paper
          elevation={0}
          sx={{
            background: "linear-gradient(135deg, #00024c 0%, #1a2b6b 100%)",
            color: "white",
            borderRadius: 0,
            mb: 3,
          }}
        >
          <Box sx={{ px: 3, py: 3 }}>
            {/* Header Content */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  sx={{
                    bgcolor: "rgba(255,255,255,0.2)",
                    mr: 2,
                    width: 56,
                    height: 56,
                  }}
                >
                  <Assignment sx={{ fontSize: 28 }} />
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                    {application ? application.LaboratoryName : "AC Process"}
                  </Typography>
                  <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
                    Manage Assessment Committee dates and process
                  </Typography>
                  {application && (
                    <Box
                      sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}
                    >
                      <Chip
                        label={`Application No: ${application.ApplicationNo}`}
                        variant="outlined"
                        size="small"
                        sx={{
                          color: "white",
                          borderColor: "rgba(255,255,255,0.7)",
                        }}
                      />
                      <Chip
                        label={`Lab Type: ${application.LabType}`}
                        variant="outlined"
                        size="small"
                        sx={{
                          color: "white",
                          borderColor: "rgba(255,255,255,0.7)",
                        }}
                      />
                      <Chip
                        label={`Assessment: ${application.AssessmentType}`}
                        variant="outlined"
                        size="small"
                        sx={{
                          color: "white",
                          borderColor: "rgba(255,255,255,0.7)",
                        }}
                      />
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Paper>

        {/* Final Status Section */}
        {showFinalStatus && (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Paper
                sx={{
                  p: 3,
                  mt: 2,
                  borderRadius: 3,
                  background: "rgba(102, 126, 234, 0.05)",
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h5">
                    Final Status
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    {/* <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={handleForm11}
                    >
                      Form 11
                    </Button> */}
                    {/* <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={handleEditCertificate}
                    >
                      Edit Certificate
                    </Button> */}
                    {application?.CommunicationLetterSent === 1 && (
                      <Button
                        variant="contained"
                        size="small"
                        color="info"
                        startIcon={<Visibility />}
                        onClick={handleViewCommunicationLetter}
                      >
                        View Communication Letter
                      </Button>
                    )}
                    {hasDecisionData && (
                      <Button
                        variant="contained"
                        size="small"
                        color="success"
                        startIcon={<Visibility />}
                        onClick={handleViewLetter}
                      >
                        View Decision Letter
                      </Button>
                    )}
                    {(stage === "7" ||
                      stage === "7c" ||
                      stage === "7d" ||
                      stage === "7e" ||
                      stage === "7f" ||
                      stage === "7g" ||
                      stage === "7b" ||
                      stage === "7a" ||
                      stage === "12" ||
                      stage === "12a" ||
                      stage === "12b"
                    ) && (
                        <Button
                          variant="contained"
                          size="small"
                          color="success"
                          onClick={() => {
                            const url = `/main/advisory?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&assessmentId=${encryptText(assessmentId)}&labTypeId=${application?.LabTypeId || '3'}`;
                            navigate(url);
                          }}
                        >
                          Advisory
                        </Button>
                      )}
                    <Button
                      variant="outlined"
                      size="small"
                      color="primary"
                      startIcon={<Download />}
                      onClick={() => handleOpenCertificateDialog("download")}
                      disabled={loadingScopeData}
                    >
                      {loadingScopeData ? 'Loading...' : 'Download Certificate'}
                    </Button>
                  </Box>
                </Box>

                {/* MOM File Data Display */}
                {momFileData && (
                  <Box
                    sx={{
                      mt: 2,
                      mb: 3,
                      p: 2,
                      borderRadius: 2,
                      background: "white",
                      boxShadow: 1,
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, mb: 2, color: "#667eea" }}
                    >
                      MOM File Details
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ fontWeight: 600 }}
                          >
                            MOM Word File:
                          </Typography>
                          <Button
                            size="small"
                            startIcon={<Visibility />}
                            onClick={() =>
                              momFileData.MOMfile ? handleFileOpen(momFileData.MOMfile) : showSnackbar('No Word file available', 'error')
                            }
                            variant="outlined"
                            sx={{ textTransform: "none" }}
                          >
                            View
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ fontWeight: 600 }}
                          >
                            MOM Pdf File:
                          </Typography>
                          <Button
                            size="small"
                            startIcon={<Visibility />}
                            onClick={() =>
                              momFileData.MOM_Format ? handleFileOpen(momFileData.MOM_Format) : showSnackbar('No PDF file available', 'error')
                            }
                            variant="outlined"
                            sx={{ textTransform: "none" }}
                          >
                            View
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ fontWeight: 600 }}
                          >
                            From Date:
                          </Typography>
                          <Typography variant="body1">
                            {momFileData.FromDate}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ fontWeight: 600 }}
                          >
                            To Date:
                          </Typography>
                          <Typography variant="body1">
                            {momFileData.ToDate}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}

                <Grid container spacing={2} sx={{ mt: 2 }}>
                  {/* Status Dropdown */}
                  <Grid item xs={12}>
                    <FormControl fullWidth required disabled>
                      <InputLabel>Final Status</InputLabel>
                      <Select
                        value={ddlStatus}
                        onChange={(e) => handleStatusChange(e.target.value)}
                        label="Final Status"
                      >
                        <MenuItem value="0">-----Select---</MenuItem>
                        <MenuItem value="Accreditation">Accredited</MenuItem>
                        <MenuItem value="Accreditation With Advisory">
                          Accredited With Advisory
                        </MenuItem>
                        <MenuItem value="Accredited with advisory including show cause notice">
                          Accredited with advisory including Showcause/Subject
                          to
                        </MenuItem>
                        <MenuItem value="Show Cause">
                          Showcause/Subject to
                        </MenuItem>
                        <MenuItem value="Close">Closed</MenuItem>
                        <MenuItem value="Denial">
                          Denial of Accreditation
                        </MenuItem>
                        <MenuItem value="Abeyance">Abeyance</MenuItem>
                        <MenuItem value="Suspension">Suspension</MenuItem>
                        <MenuItem value="Force Withdrwal">
                          Withdrawal of Accreditation
                        </MenuItem>
                        <MenuItem value="Debar from Reapply Certification Preparation">
                          Debar from Reapply
                        </MenuItem>
                        <MenuItem value="Mark for Re Assessment">
                          On-site / Supplementary Visit
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Generate New Certificate Number */}
                  {showDivC && application.AssessmentTypeId !== 1 && (
                    <Grid item xs={12}>
                      <Typography variant="body2" gutterBottom>
                        Do you want to generate a new certificate number? *
                      </Typography>
                      <RadioGroup
                        row
                        value={rblCertNo}
                        onChange={(e) => handleCertNoChange(e.target.value)}
                      >
                        <FormControlLabel
                          value="1"
                          control={<Radio disabled />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="0"
                          control={<Radio disabled />}
                          label="No"
                        />
                      </RadioGroup>
                    </Grid>
                  )}

                  {showLnkGenerateBtn && (
                    <Grid item xs={12} md={6}>
                      <Typography variant="body2" color="textSecondary">
                        Certificate Number Generation Required
                      </Typography>
                    </Grid>
                  )}

                  {/* Certificate Number */}
                  {showDivCertno && (
                    <Grid item xs={12}>
                      <Grid container spacing={1}>
                        <Grid item xs={4}>
                          <TextField
                            fullWidth
                            label="Prefix"
                            value={txtBoxCert}
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <TextField
                            fullWidth
                            required
                            label="Certificate No."
                            value={txtCertificateNo}
                            onChange={(e) => {
                              const value = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 5);
                              setTxtCertificateNo(value);
                            }}
                            inputProps={{ maxLength: 5 }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                  {/* Issue Date */}
                  {/* {showDivIssueDate && (
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        type="date"
                        label="Issue Date"
                        value={txtIssueDate}
                        onChange={handleIssueDateChange}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                  )} */}

                  {/* To Date */}
                  {/* {showDivToDate && (
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        type="date"
                        label="Validity Till"
                        value={txtToDate}
                        onChange={(e) => {
                          setTxtToDate(e.target.value);
                          setTimeout(calculateExpectedDate, 100);
                        }}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          min: new Date().toISOString().split("T")[0],
                        }}
                        helperText="In case of extended validity, the extended validity to be punched"
                      />
                    </Grid>
                  )} */}

                  {/* Next Due Activity */}
                  {showDivNextDueActivity && (
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth required disabled>
                        <InputLabel>Next Due Activity</InputLabel>
                        <Select
                          value={ddlNextDueActivity}
                          onChange={(e) => {
                            setDdlNextDueActivity(e.target.value);
                            setTimeout(calculateExpectedDate, 100);
                          }}
                          label="Next Due Activity"
                        >
                          <MenuItem value="0">-- Select --</MenuItem>
                          <MenuItem value="Desktop Application">
                            Desktop Application
                          </MenuItem>
                          <MenuItem value="Surveillance Application">
                            Surveillance Application
                          </MenuItem>
                          <MenuItem value="Renewal Application">
                            Renewal Application
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  )}

                  {/* Expected Date */}
                  {showDivExpectedDate && (
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        required
                        type="date"
                        label="Expected Date of Application"
                        value={txtExpectedDate}
                        onChange={(e) => setTxtExpectedDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        disabled
                      />
                    </Grid>
                  )}

                  {/* Amendment Date */}
                  {/* {showDivAmendment && (
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        type="date"
                        label="Amendment Date"
                        value={txtAmendmentDate}
                        onChange={handleAmendmentDateChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          min: txtIssueDate || undefined,
                          max: txtToDate || undefined,
                        }}
                        helperText="Must be between Issue Date and Validity Till"
                      />
                    </Grid>
                  )} */}

                  {/* IAC Minutes Upload */}
                  {ddlStatus != 0 && (
                    <Grid item xs={12} md={6}>
                      <FileUploadComponent
                        key={`iacFile-${fileUploadKey}`}
                        fieldName="iacFile"
                        label="Upload IAC minutes (If Applicable)"
                        orgId={localStorage.getItem("orgId") || "do"}
                        section="iac-documents"
                        accept=".pdf,.PDF"
                        maxSize={10}
                        onChange={handleFileUploadChange}
                        initialFile={uploadedIACFile}
                        localDeleteOnly={false}
                        required={false}
                        disabled={true}
                      />
                    </Grid>
                  )}

                  {/* Remarks */}
                  {showDivRemarks && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        multiline
                        rows={3}
                        label="Remarks"
                        value={txtRemark}
                        onChange={(e) => setTxtRemark(e.target.value)}
                        disabled
                      />
                    </Grid>
                  )}

                  {/* Show Cause Remarks */}
                  {showDivShowcauseRemarks && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={4}
                        label="Remarks"
                        value={txtShowcauseRemarks}
                        onChange={(e) => setTxtShowcauseRemarks(e.target.value)}
                        disabled
                      />
                    </Grid>
                  )}

                  {/* Disciplines */}
                  {showDivDiscipline && disciplines.length > 0 && (
                    <Grid item xs={12}>
                      <Typography variant="body2" gutterBottom>
                        Discipline
                      </Typography>
                      <Grid container spacing={1}>
                        {disciplines.map((disc) => (
                          <Grid item xs={12} sm={6} key={disc.id}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedDisciplines.includes(
                                    disc.id,
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedDisciplines([
                                        ...selectedDisciplines,
                                        disc.id,
                                      ]);
                                    } else {
                                      setSelectedDisciplines(
                                        selectedDisciplines.filter(
                                          (id) => id !== disc.id,
                                        ),
                                      );
                                    }
                                  }}
                                  disabled
                                />
                              }
                              label={disc.disciplineName}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  )}

                  {/* Re-Assessment Type */}
                  {showDivReAssessType && (
                    <Grid item xs={12}>
                      <Typography variant="body2" gutterBottom>
                        Assessment Type
                      </Typography>
                      <RadioGroup
                        row
                        value={rbAssesstype}
                        onChange={(e) => setRbAssesstype(e.target.value)}
                      >
                        <FormControlLabel
                          value="Full Assessment"
                          control={<Radio disabled />}
                          label="Full Assessment"
                        />
                        <FormControlLabel
                          value="Partial Assessment"
                          control={<Radio disabled />}
                          label="Partial Assessment"
                        />
                      </RadioGroup>
                    </Grid>
                  )}

                  {/* Adverse Decision - Cooling Off Period */}
                  {showAdverseDecision && (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="body2" gutterBottom>
                          Whether Cooling off Period is applicable? *
                        </Typography>
                        <RadioGroup
                          row
                          value={rbCoolingPeriod}
                          onChange={(e) =>
                            handleCoolingPeriodChange(e.target.value)
                          }
                        >
                          <FormControlLabel
                            value="1"
                            control={<Radio disabled />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="0"
                            control={<Radio disabled />}
                            label="No"
                          />
                        </RadioGroup>
                      </Grid>

                      {rbCoolingPeriod === "1" && (
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            required
                            type="date"
                            label="Cooling off duration (CAB can apply afresh on or after)"
                            value={txtCollingPeriod}
                            onChange={(e) =>
                              setTxtCollingPeriod(e.target.value)
                            }
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                      )}
                    </>
                  )}

                  {/* Rejected Remarks (for 7e stage) */}
                  {showDivRejctdRmrk && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={4}
                        disabled
                        label="Rejected Remark"
                        value={txtRejectedRemarks}
                      />
                    </Grid>
                  )}
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        )}

        {/* Certificate Download Dialog */}
        <CertificateDialog
          open={showCertificateDialog}
          onClose={() => setShowCertificateDialog(false)}
          scopeData={scopeData}
          certificateData={{
            labName: certificateMainData?.labName || '',
            address: certificateMainData?.address || '',
            certificateNumber: certificateMainData?.certificateNumber || '',
            issueDate: certificateMainData?.issuedate ? new Date(certificateMainData?.issuedate).toLocaleDateString('en-GB') : '',
            validUntil: certificateMainData?.validtill ? new Date(certificateMainData?.validtill).toLocaleDateString('en-GB') : '',
            legalEntity: certificateMainData?.legalEntity || '',
            field: certificateMainData?.field || '',
            standard: certificateMainData?.standard || '',
            directorname: certificateMainData?.directorname || '',
            directorsignature: certificateMainData?.directorsignature || '',
            ceoname: certificateMainData?.ceoname || '',
            appId: appId,
            orgId: orgIdFromUrl,
            records: []
          }}
          loading={loadingScopeData}
        />

        {/* Snackbar for notifications */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </LocalizationProvider>
  );
};

export default ACProcess;
